<div
  class="animate__animated h-full"
  shabicInViewport
  [inViewportClass]="animation"
  [ngClass]="classes"
>
  <ng-content></ng-content>
</div>
